import angular from 'angular';

class PrincipalOffreApiCtrl {
    /* @ngInject */
    constructor(PrincipalSvc, $location, $state, AuthSvc, logger, DocumentModelDA) {
        this.PrincipalSvc = PrincipalSvc;
        this.$state = $state;
        this.AuthSvc = AuthSvc;
        this.logger = logger;
        this.DocumentModelDA = DocumentModelDA;
        this.filteredOptions1 = [];
        this.filteredOptions2 = [];
        this.FiltredAttributes = [];
    }

    $onInit() {
        // Indique si le formulaire est en cours de soumission
        this.isSubmitting = false;

        // reset OffreApiConfig
        this.resetoffresApiConfig = angular.copy(this.offresApiConfig);

        // Récupérer que les attributs de type texte et numérique
        this.FiltredAttributes = this.dictionnaireAttributs.filter(a => a.type === 'Number' || a.type === 'Text');

        this.previousFirstSelectorState = null;

        this.previousSecondSelectorState = null;

        /* Indique si disable ou non offre API */
        this.disableOffreApi = function () {
            return !this.hasGisPlatform() || !this.isEditAuthorized();
        };

        // Call the filtering functions initially to set up the initial options
        this.filterOptionsForSelector2();
        this.filterOptionsForSelector1();
    }

    /* Indique si le DO importé est paramétré sur la plateforme GIS*/
    hasGisPlatform() {
        return (
            this.principal.detail.dematPlatforms &&
            this.principal.detail.dematPlatforms.some(element => element.family === 'GIS')
        );
    }

    isInvoiceRetrievalActive(offreApiConfig) {
        return this.isInvoiceRetrieval(offreApiConfig) && offreApiConfig.active;
    }

    isInvoiceRetrieval(offreApiConfig) {
        return offreApiConfig.offerApi.eid === 'INVOICE_RETRIEVAL';
    }

    shouldDisplayFilter(offreApiConfig) {
        return offreApiConfig.offerApi.filters && this.isInvoiceRetrieval(offreApiConfig);
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    getInvoiceRetrievalConfig() {
        return this.offresApiConfig.find(config => this.isInvoiceRetrieval(config));
    }

    // Function to filter options for Selector 2 based on the selection made in Selector 1
    filterOptionsForSelector2() {
        const offreApiConfig = this.getInvoiceRetrievalConfig();
        if (!offreApiConfig) return; // If no matching config found, return

        this.filteredOptions2 = this.FiltredAttributes.filter(item => {
            return item.path !== offreApiConfig.path1;
        });

        // Check if the selector was previously set and is now cleared
        if (this.previousFirstSelectorState && !offreApiConfig.path1) {
            offreApiConfig.value1 = null; // Reset the associated value
        }
        // Update the previous state of the selector
        this.previousFirstSelectorState = offreApiConfig.path1;
    }

    // Function to filter options for Selector 1 based on the selection made in Selector 2
    filterOptionsForSelector1() {
        const offreApiConfig = this.getInvoiceRetrievalConfig();
        if (!offreApiConfig) return; // If no matching config found, return

        this.filteredOptions1 = this.FiltredAttributes.filter(item => {
            return item.path !== offreApiConfig.path2;
        });

        if (this.previousSecondSelectorState && !offreApiConfig.path2) {
            offreApiConfig.value2 = null; // Reset the associated value
        }
        this.previousSecondSelectorState = offreApiConfig.path2;
    }

    back() {
        this.$state.go('do', { tabName: 'principal' });
    }
    cancel() {
        this.offresApiConfig = angular.copy(this.resetoffresApiConfig);
    }

    sendOffer() {
        if (this.form.$valid && !this.isSubmitting) {
            this.isSubmitting = true;
            this.PrincipalSvc.addOfferApi(this.PrincipalSvc.getPrincipalId(), this.offresApiConfig).then(
                data => {
                    this.form.$setPristine();
                    this.logger.success('success.update', data, null, { entityName: "Le Donneur d'ordre" });
                    this.isSubmitting = false;
                    // récupérer les données de la base de données
                    this.offresApiConfig = data;
                },
                error => {
                    this.logger.error('error.update', error);
                    this.isSubmitting = false;
                }
            );
        }
    }
}

angular.module('app.principal').component('principalOffreApi', {
    templateUrl: require('./principal-offreApi.html'),
    controller: PrincipalOffreApiCtrl,
    bindings: {
        principal: '<',
        functionalType: '<',
        dictionnaireAttributs: '<',
        offresApiConfig: '<',
    },
});
